import * as Font from "expo-font";
import {Asset} from "expo-asset";

export const loadAssets = async () => {
    await Font.loadAsync({
        'ubuntu-regular': require('../../../assets/fonts/Ubuntu/Ubuntu-Regular.ttf'),
        'ubuntu-bold': require('../../../assets/fonts/Ubuntu/Ubuntu-Bold.ttf'),
        'ubuntu-bold-italic': require('../../../assets/fonts/Ubuntu/Ubuntu-BoldItalic.ttf'),
        'ubuntu-italic': require('../../../assets/fonts/Ubuntu/Ubuntu-Italic.ttf'),
        'ubuntu-light': require('../../../assets/fonts/Ubuntu/Ubuntu-Light.ttf'),
        'ubuntu-light-italic': require('../../../assets/fonts/Ubuntu/Ubuntu-LightItalic.ttf'),
        'ubuntu-medium': require('../../../assets/fonts/Ubuntu/Ubuntu-Medium.ttf'),
        'ubuntu-mediumItalic': require('../../../assets/fonts/Ubuntu/Ubuntu-MediumItalic.ttf'),

        // Add icon font for web and native compatibility
        'Ionicons': require('@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/Ionicons.ttf'),
        'AntDesign': require('@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/AntDesign.ttf'),
        'FontAwesome': require('@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/FontAwesome.ttf'),
        'MaterialCommunityIcons': require('@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf'),
        'MaterialIcons': require('@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialIcons.ttf'),
    });

    await Asset.loadAsync([
        require('../../../assets/images/meeting-room-display-default.png'),
        require('../../../assets/images/confirmed-icon.png'),
        require('../../../assets/images/extend-icon.png'),
        require('../../../assets/images/end-icon.png'),
    ]);
}